import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const setNccSettingsIntoLocalStorage = ({isModeForChildren, isModeHSV}) => {
  return localStorage.setItem('nccSettings', JSON.stringify({
    isModeForChildren,
    isModeHSV
  }));
};

const getNccSettingsFromLocalStorage = () => {
  const localStorageState = localStorage.getItem('nccSettings');

  if (localStorageState && JSON.parse(localStorageState)) {
    return JSON.parse(localStorageState);
  }

  return {
    isModeForChildren: false,
    isModeHSV: true
  };
};

const {isModeForChildren, isModeHSV} = getNccSettingsFromLocalStorage();

const store = new Vuex.Store({
  state: {
    selectedQuestion: window.qnaItem || {},
    showAnswer: false,
    showVideoBar: false,
    showComment: false,
    showPrayer: false,
    isModeForChildren,
    isModeHSV
  },
  actions: {
    fetchQuestion({commit}, {postUrl}) {
      return new Promise((resolve, reject) => {
        axios.get(postUrl)
          .then(response => {
              commit('SET_SELECTED_QUESTION', response.data)
              resolve(response.data);
          })
          .catch(reject);
      })
    },
    selectQuestion({commit}, {question}) {
      commit('SET_SELECTED_QUESTION', question)
    }
  },
  mutations: {
    SET_MODE_FOR_CHILDREN(state, isModeForChildren = false) {
      state.isModeForChildren = isModeForChildren;

      setNccSettingsIntoLocalStorage(state)
    },
    SET_MODE_HSV(state, isModeHSV = false) {
      state.isModeHSV = isModeHSV;

      setNccSettingsIntoLocalStorage(state)
    },
    SET_SELECTED_QUESTION(state, question = {}) {
      state.selectedQuestion = question;
    },
    SET_SHOW_ANSWER(state, showAnswer) {
      state.showAnswer = showAnswer
    },
    SET_SHOW_VIDEOBAR(state, showVideoBar = false) {
      state.showVideoBar = showVideoBar
    },
    SET_SHOW_COMMENT(state, showComment = false) {
      state.showComment = showComment
    },
    SET_SHOW_PRAYER(state, showPrayer = false) {
      state.showPrayer = showPrayer
    }
  },
  getters: {
    selectedQuestion(state) {
      return state.selectedQuestion
    },
    showVideoBar(state) {
      return state.showVideoBar
    },
    showComment(state) {
      return state.showComment
    },
    showPrayer(state) {
      return state.showPrayer
    },
    showAnswer(state) {
      return state.showAnswer
    },
    isModeForChildren(state) {
      return state.isModeForChildren
    },
    isModeHSV(state) {
      return state.isModeHSV
    }
  }
});

export default store;
